/* Kucaklo premium bölümleri — her bölüm [data-kk="..."] ile kendini başlatır. */
(function () {
  if (window.kkPremium) return;

  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealObserver.unobserve(e.target); }
        });
      }, { threshold: 0.15 })
    : null;

  // Shrine PRO'da yerleşik yumuşak kaydırma çalışmıyor; kendi animasyonumuzla kaydırıyoruz.
  function animateScrollTo(top) {
    var start = window.scrollY, dist = top - start, t0 = null, dur = 700;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo({ top: top, behavior: 'instant' }); return; }
    var done = false;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      window.scrollTo({ top: start + dist * e, behavior: 'instant' });
      if (p < 1) requestAnimationFrame(step); else done = true;
    }
    requestAnimationFrame(step);
    // Animasyon kareleri çalışmazsa (ör. arka plandaki sekme) doğrudan hedefe git
    setTimeout(function () { if (!done) { done = true; window.scrollTo({ top: top, behavior: 'instant' }); } }, dur + 300);
  }

  // Üstteki paket kutusuna (Kaching Bundles) ya da sepete ekle formuna kaydır
  function scrollToBuy() {
    var target = document.querySelector('.kaching-bundles') || document.querySelector('form[action*="/cart/add"]');
    if (!target) { animateScrollTo(0); return; }
    var r = target.getBoundingClientRect();
    animateScrollTo(Math.max(0, r.top + window.scrollY - Math.max(80, (window.innerHeight - r.height) / 2)));
  }

  // Paket kutusundaki beden menülerinde ilgili bedeni seç (ör. "L / 4-7 Kilogram")
  function selectSize(size) {
    document.querySelectorAll('select.kaching-bundles__bar-variant-select, .kaching-bundles select').forEach(function (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].value.indexOf(size + ' /') === 0) {
          sel.value = sel.options[i].value;
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    });
  }

  var inits = {
    fit: function (root) {
      var sizes = [{ s: 'S', max: 2, r: '0–2 kg' }, { s: 'M', max: 4, r: '2–4 kg' }, { s: 'L', max: 7, r: '4–7 kg' }, { s: 'XL', max: 12, r: '7–12 kg' }];
      var kg = root.querySelector('.kk-slider'), current = 'L';
      var pills = root.querySelectorAll('.kk-pill');
      function update() {
        var v = parseFloat(kg.value), z = sizes.find(function (x) { return v <= x.max; });
        current = z.s;
        root.querySelector('[data-kk-kg]').textContent = String(v).replace('.', ',');
        root.querySelector('[data-kk-size]').textContent = z.s;
        root.querySelector('[data-kk-range]').textContent = z.r;
        root.querySelector('[data-kk-tip]').textContent = root.getAttribute('data-tip-' + z.s.toLowerCase()) || '';
        root.querySelectorAll('.kk-scale div').forEach(function (d) { d.classList.toggle('is-on', d.dataset.s === z.s); });
      }
      kg.addEventListener('input', function () {
        pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
        update();
      });
      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          pills.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          p.setAttribute('aria-pressed', 'true');
          kg.value = p.dataset.kg;
          update();
        });
      });
      root.querySelector('[data-kk-choose]').addEventListener('click', function (e) {
        e.preventDefault();
        selectSize(current);
        scrollToBuy();
      });
      update();
    },

    explore: function (root) {
      var stage = root.querySelector('.kk-stage'), bars = root.querySelector('.kk-bars'), body = root.querySelector('.kk-panel__body');
      var spots = Array.prototype.map.call(root.querySelectorAll('[data-kk-spot]'), function (el) {
        return { x: el.dataset.x, y: el.dataset.y, t: el.dataset.title, p: el.dataset.text };
      });
      if (!spots.length) return;
      var cur = 0, dots = [];
      root.querySelector('[data-kk-total]').textContent = spots.length;
      spots.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'kk-dot'; d.style.left = s.x + '%'; d.style.top = s.y + '%';
        d.textContent = i + 1; d.setAttribute('aria-label', s.t);
        d.addEventListener('click', function () { show(i); });
        stage.appendChild(d); dots.push(d);
        bars.appendChild(document.createElement('i'));
      });
      function show(i) {
        cur = (i + spots.length) % spots.length;
        body.classList.add('is-out');
        setTimeout(function () {
          root.querySelector('[data-kk-n]').textContent = cur + 1;
          root.querySelector('[data-kk-title]').textContent = spots[cur].t;
          root.querySelector('[data-kk-text]').textContent = spots[cur].p;
          body.classList.remove('is-out');
        }, 180);
        dots.forEach(function (d, k) { d.setAttribute('aria-pressed', k === cur); });
        bars.querySelectorAll('i').forEach(function (b, k) { b.classList.toggle('is-on', k === cur); });
      }
      root.querySelector('[data-kk-prev]').addEventListener('click', function () { show(cur - 1); });
      root.querySelector('[data-kk-next]').addEventListener('click', function () { show(cur + 1); });
      show(0);
    },

    show: function (root) {
      var main = root.querySelector('.kk-show__main img'), thumbs = root.querySelectorAll('.kk-show__thumbs button');
      thumbs.forEach(function (b) {
        b.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          main.style.opacity = 0;
          setTimeout(function () { main.src = b.dataset.full; main.removeAttribute('srcset'); main.style.opacity = 1; }, 200);
        });
      });
    },

    vids: function (root) {
      var vids = root.querySelectorAll('video[data-kk-vid]');
      function tryPlay(v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      vids.forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
        // Döngü bazı telefonlarda takılıyor: bitince elle başa sar
        v.addEventListener('ended', function () { v.currentTime = 0; tryPlay(v); });
        // Ağ takılırsa toparlanınca yeniden başlat
        v.addEventListener('stalled', function () { if (v.dataset.kkVisible === '1') { v.load(); tryPlay(v); } });
        // Düşük güç modunda otomatik oynatma engellenirse dokununca oynasın
        v.addEventListener('click', function () { if (v.paused) tryPlay(v); else v.pause(); });
      });
      // Sadece ekranda görünen videolar oynasın (telefonda 3 video aynı anda oynayınca donuyor)
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target; v.dataset.kkVisible = e.isIntersecting ? '1' : '0';
            if (e.isIntersecting) { if (v.preload !== 'auto') v.preload = 'auto'; tryPlay(v); } else v.pause();
          });
        }, { threshold: 0.35 });
        vids.forEach(function (v) { io.observe(v); });
      } else vids.forEach(tryPlay);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) vids.forEach(function (v) { if (v.dataset.kkVisible === '1') tryPlay(v); });
      });
    },

    day: function (root) {
      var track = root.querySelector('.kk-track');
      root.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.querySelector('.kk-moment');
          if (card) track.scrollBy({ left: +b.dataset.dir * (card.offsetWidth + 20), behavior: 'smooth' });
        });
      });
    }
  };

  function init(scope) {
    scope.querySelectorAll('[data-kk]').forEach(function (root) {
      if (root.dataset.kkReady) return;
      root.dataset.kkReady = '1';
      var fn = inits[root.dataset.kk];
      if (fn) fn(root);
    });
    scope.querySelectorAll('.kk-reveal').forEach(function (el) {
      if (revealObserver) revealObserver.observe(el); else el.classList.add('is-in');
    });
    scope.querySelectorAll('[data-kk-buy]').forEach(function (a) {
      if (a.dataset.kkBuyReady) return;
      a.dataset.kkBuyReady = '1';
      a.addEventListener('click', function (e) { e.preventDefault(); scrollToBuy(); });
    });
  }

  // Ürün sayfası: Pumper paket kutularına "pantolon başı · kazanç" satırı ekle.
  // Sadece metin ekler; uygulamanın seçim/sepete ekleme davranışına dokunmaz.
  function parseTL(s) { return parseFloat(String(s).replace(/[^\d.,]/g, '').replace(/,/g, '')) || 0; }
  function fmtTL(v) { return v.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL'; }
  var badgeTpl = null;
  function decorateTiers() {
    var blocks = document.querySelectorAll('.pmpr_tier_list .pumper_block__cb');
    if (!blocks.length) return;
    blocks.forEach(function (b) {
      var title = b.querySelector('.pmpr\\:text-base'), priceEl = b.querySelector('.tier-price__main');
      var sub = b.querySelector('[class*="offerSubtitle"]');
      if (!title || !priceEl || !sub) return;
      var m = title.textContent.match(/(\d+)\s*Adet/i); if (!m) return;
      var sets = parseInt(m[1], 10) / 2, price = parseTL(priceEl.textContent);
      if (!sets || !price) return;
      // Rozetler: 4 adet "En çok tercih edilen", 6 adet "En uygun fiyat", 2 adette rozet yok
      var badge = { 2: 'EN ÇOK TERCİH EDİLEN', 3: 'EN UYGUN FİYAT' }[sets] || '';
      var wrap = b.querySelector('.tier-label-wrapper');
      if (!badgeTpl && wrap) badgeTpl = wrap.cloneNode(true);
      if (!badge) { if (wrap && wrap.style.display !== 'none') wrap.style.display = 'none'; }
      else {
        if (!wrap && badgeTpl) { var right = b.querySelector('[class*="content--right"]'); if (right) { wrap = badgeTpl.cloneNode(true); right.insertBefore(wrap, right.firstChild); } }
        if (wrap) {
          if (wrap.style.display === 'none') wrap.style.display = '';
          var lab = wrap.querySelector('.tier-label');
          if (lab && lab.textContent !== badge) lab.textContent = badge;
        }
      }
      var ex = b.querySelector('.kk-tier-extra');
      if (ex) ex.remove();
    });
  }
  // Tahmini teslim tarihi: bugünden itibaren 1–3 iş günü
  function fillEta() {
    var months = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
    function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
    document.querySelectorAll('[data-kk-eta]').forEach(function (el) {
      var a = add(parseInt(el.dataset.min || '1', 10)), b = add(parseInt(el.dataset.max || '3', 10));
      el.textContent = a.getMonth() === b.getMonth() ? a.getDate() + '–' + b.getDate() + ' ' + months[b.getMonth()] : a.getDate() + ' ' + months[a.getMonth()] + ' – ' + b.getDate() + ' ' + months[b.getMonth()];
    });
  }
  if (document.querySelector('[data-kk-eta]') || document.querySelector('#svelte-bundle-widget')) {
    var tierTimer;
    var mo = new MutationObserver(function () { clearTimeout(tierTimer); tierTimer = setTimeout(decorateTiers, 120); });
    var startBuy = function () { fillEta(); decorateTiers(); mo.observe(document.querySelector('#svelte-bundle-widget') || document.body, { childList: true, subtree: true, characterData: true }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startBuy); else startBuy();
  }

  window.kkPremium = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Tema editöründe bölüm eklenince/değişince yeniden başlat
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
